/* eslint-disable @typescript-eslint/no-explicit-any */
import { Switch } from "@/components/ui/switch";
import { BadgeCell } from "./badge-cell";

export const ReactTableCell = ({
  header,
  value,
  inlineUpdate,
  row,
  activePermission,
}: any) => {
  switch (header) {
    case "read_body_content": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          <Switch
            checked={value}
            onCheckedChange={(prop) =>
              inlineUpdate({ ...row.originData, read_body_content: prop })
            }
            disabled={activePermission?.update !== true}
          />
        </span>
      );
    }
    case "read_attachments": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          <Switch
            checked={value}
            onCheckedChange={(prop) =>
              inlineUpdate({ ...row.originData, read_attachments: prop })
            }
            disabled={activePermission?.update !== true}
          />
        </span>
      );
    }
    case "enable": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          {value ? "Enable" : "Disable"}
        </span>
      );
    }
    case "matching_keys": {
      return <BadgeCell list={value} />;
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
